import { SET_PROFILS } from '../types/profilsTypes';

const initialState = {
  list: [],
  loading: false,
  selected: null,
};

const profilReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROFILS:
      return { ...state, list: action.payload };
    default:
      return state;
  }
};

export default profilReducer;
